export type PageDetails = {
  pageTitle: string;
  stepNumber: string;
  stepName: string;
};

export const CCPAEligibility: PageDetails = {
  pageTitle: "business onboarding - eligibility",
  stepNumber: "step_1",
  stepName: "step_eligibility"
};

export const CCPARiamSignIn: PageDetails = {
  pageTitle: "business onboarding - RIAM sign in + rest",
  stepNumber: "step_2",
  stepName: "step_sign_in"
};
